import ManoeuvreElectrique from 'assets/img/manoeuvre-electrique.png';
import gauche from 'assets/img/stock/gauche.png';
import droite from 'assets/img/stock/droite.png';
import formInputsTypes, {
    createAxe,
    LameColor,
    LameTaille,
    Moteur,
} from '../simulatorConstant';
import { MesureLargeur } from '../rideauMetallique/data';




const TypeMesureHaut = {
    id: 'VR-TR-VRC-TMH',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureHauteur',
    className: 'col-6',
    label: 'Mesure selon hauteur',
    nextStepData: LameTaille(
        LameColor(Moteur(false), 'Couleur de lame'),
    ),
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const hauteur = currentFormValue?.values?.hauteur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Hauteur : ${hauteur} mm FINI`

            },
            {
                id: '+E',
                label: '+E',
                value: '+E',
                nextStep: false,
                description: `- Hauteur : ${hauteur} mm +E`


            },

        ]
        fnSuccess(options);
    },
};

const hieghtTablier = {
    id: 'VR-TR-VRC-H',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'hauteur',
    className: 'col-6',
    label: 'Hauteur entre murs (mm)',
    defaultValue: 0,
    nextStepData: TypeMesureHaut,
    nextStep: false,
    notIncludeDescription: true,
    validation: (value) => {
        return value > 0;
    },
};
const typeMesureLargeur = {
    id: 'VR-TR-VRC-TMW',
    type: formInputsTypes?.RADIO_INPUT,
    name: 'typeMesureLargeur',
    className: 'col-6',
    label: 'Mesure selon largeur',
    nextStepData: hieghtTablier,
    nextStep: false,
    fetchData: (currentFormValue, fnSuccess) => {
        const largeur = currentFormValue?.values?.largeur?.value;

        const options = [
            {
                id: 'RMFN',
                label: 'FINI',
                value: 'FINI',
                nextStep: false,
                description: `- Largeur : ${largeur} mm FINI`

            },
            {
                id: 'RME',
                label: 'DC',
                value: 'DC',
                nextStep: false,
                description: `- Largeur : ${largeur} mm D.C`


            },

        ]
        fnSuccess(options);
    },
};

const completMotorise = {
    id: 'VR-TR-VRC-W',
    type: formInputsTypes?.INPUT_NUMBER,
    name: 'largeur',
    className: 'col-6',
    label: 'Largeur entre murs (mm)',
    placeholder: '0',
    defaultValue: 0,
    nextStepData: typeMesureLargeur,
    notIncludeDescription: true,
    nextStep: false,
    validation: (value) => {
        return value > 0;
    },
};

export default completMotorise;
